import styled from 'styled-components';

export const FeatureContainer = styled.div`
  background: #000000;
  height: 500vh;
  max-height: 100vh;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: center;
  color: #fff;
  text-align: center;
  padding: 0 1rem;

  h1 {
    font-size: clamp(2rem, 3vw, 5rem);
    margin-top: 20px;
  }

  p {
    margin-bottom: 1rem;
    font-size: clamp(1rem, 2vw, 2rem);
    margin-top: 20px;
    margin-left: 10px;
  }
`;
export const FeatureButton = styled.div`
  font-size: 1.4rem;
  margin-top: 15px;
  padding: 0.6rem 5rem;
  border: none;
  background: #ffc500;
  color: #000;
  transition: 0.2s ease-out;

  
`;


